import React, { Component } from "react";
import "./App.css";

import MenuCard from "./components/menu-card/MenuCard";
import Authentication from "./pages/authentication/Authentication";
import Header from "./components/header/Header";

// comment

const initialState = {
  authenticated: false,
  account: {
    name: "",
    authUser: 0,
  },
};

const tribalCredit = require("./tribalCredit.png");
const mesh = require("./mesh_ai.png");
const avodocs = require("./avodocs.png");

export class App extends Component {
  constructor() {
    super();
    this.state = initialState;
  }

  onLogout = () => {
    this.setState(initialState);
    localStorage.removeItem("account");
  };

  onAuthenticationSuccess = (account) => {
    this.setState({ authenticated: true, account: account });
  };

  render() {
    // index of gmail account
    const authUser = this.state.account.authUser;

    return (
      <div className="App">
        <Header onLogout={this.onLogout} name={this.state.account.name} />

        {!this.state.authenticated && false ? (
          <Authentication
            onAuthenticationSuccess={this.onAuthenticationSuccess}
          />
        ) : (
          <div>
            <div className="menu">
              <MenuCard
                title="Amplitude"
                icon="https://seeklogo.com/images/A/amplitude-logo-67DFD43C34-seeklogo.com.png"
                target="https://analytics.amplitude.com/login/thndr"
              />
              <MenuCard
                title="Avodocs"
                icon={avodocs}
                target="https://www.avodocs.com/"
              />
              <MenuCard
                title="Big Query"
                icon="https://uploads-ssl.webflow.com/5d1126db676120bb4fe43762/5ef3ae6947f6c4c138c68be9_google-bigquery.png"
                target="https://console.cloud.google.com/bigquery"
              />
              <MenuCard
                title="Blog"
                icon="https://juststickers.in/wp-content/uploads/2014/05/Wordpress-Shape-Cut.png"
                target="https://wordpress.com/home/thndrapp.blog"
              />
              <MenuCard
                title="Braze"
                icon="https://iconape.com/wp-content/files/mk/370650/svg/braze-logo-icon-png-svg.png"
                target="https://dashboard.braze.com/sign_in"
              />
              <MenuCard
                title="Business Manager"
                icon="https://upload.wikimedia.org/wikipedia/commons/thumb/c/c2/F_icon.svg/768px-F_icon.svg.png"
                target={"https://business.facebook.com/thndrapp/"}
                iconSize={87}
              />
            </div>
            <div className="menu">
              <MenuCard
                title="Drive"
                icon="http://icons.iconarchive.com/icons/marcus-roberto/google-play/512/Google-Drive-icon.png"
                target={`https://drive.google.com/drive/u/${authUser}/my-drive`}
              />
              <MenuCard
                title="Eikon"
                icon="http://lh6.ggpht.com/Q_uuMxbrOSOoWFbDMhsowlCRjwqe1uacKSAWBnf-9MIbKYTolySqiGBI2HtfCqa7PY0"
                target={"https://eikon.thomsonreuters.com/index.html"}
              />
              <MenuCard
                title="Email"
                icon="https://upload.wikimedia.org/wikipedia/commons/4/4e/Gmail_Icon.png"
                target={`https://mail.google.com/mail/u/${authUser}/#inbox`}
              />
              <MenuCard
                title="Figma"
                icon="https://cdn-icons-png.flaticon.com/512/5968/5968705.png"
                target={"https://www.figma.com/"}
              />
              <MenuCard
                title="Firebase"
                icon="https://i.pinimg.com/originals/07/ca/4a/07ca4afbde70ce0c995b3f63e9c04ceb.png"
                target={
                  "https://console.firebase.google.com/project/thndr-api/overview"
                }
              />
              <MenuCard
                title="Fresh Team"
                icon="https://www.pinclipart.com/picdir/middle/570-5707502_freshworks-logo-clipart.png"
                target={"http://thndr-talent.freshteam.com/"}
              />
            </div>
            <div className="menu">
              <MenuCard
                title="Funding Tool"
                icon="https://storage.googleapis.com/images.thndr.app/portal-icons/funding.png"
                target={"https://usertool.thndr-internal.app/funding/"}
                iconSize={100}
              />
              <MenuCard
                title="Gitlab"
                icon="https://about.gitlab.com/images/press/logo/png/gitlab-icon-rgb.png"
                target="https://gitlab.com/"
              />
              <MenuCard
                title="Google Ads Manager"
                icon="https://storage.googleapis.com/gweb-uniblog-publish-prod/images/Logo.max-1500x1500.png"
                target="http://ads.google.com/"
              />
              <MenuCard
                title="Instabug"
                icon="https://res-1.cloudinary.com/crunchbase-production/image/upload/c_lpad,f_auto,q_auto:eco/ttpfzgg47alfqy9cesbs"
                target="https://instabug.com/"
              />
              <MenuCard
                title="Keycloak"
                icon="https://static-00.iconduck.com/assets.00/keycloak-icon-512x512-jss2rqxz.png"
                target="https://auth-internal.thndr.app/auth/admin/thndr-internal/console"
              />
              <MenuCard
                title="Linear"
                icon="https://asset.brandfetch.io/iduDa181eM/idYYbqOlKi.png"
                target="https://linear.app/thndr/"
                roundIcon
              />
            </div>
            <div className="menu">
              <MenuCard
                title="Mesh AI"
                icon={mesh}
                target="https://app.mesh.ai/"
              />
              <MenuCard
                title="Metabase"
                icon="https://www.knowi.com/wp-content/uploads/2020/02/metabase@2x.png"
                target="https://prod-metabase.thndr-internal.app/"
              />
              <MenuCard
                title="News"
                icon="https://cdn4.iconfinder.com/data/icons/gradient-5/50/436-512.png"
                target="https://prod.thndr.app/api/newsarticle/"
              />
              <MenuCard
                title="Notion"
                icon="data:image/png;base64,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"
                target="https://www.notion.so/thndrapp/"
              />
              <MenuCard
                title="Queuer Tool"
                icon="https://storage.googleapis.com/images.thndr.app/portal-icons/queuer.png"
                target="https://usertool.thndr-internal.app/queuer"
                iconSize={100}
              />
              <MenuCard
                title="Securities Tool"
                icon="https://storage.googleapis.com/images.thndr.app/portal-icons/securities.png"
                target="https://usertool.thndr-internal.app/securities/stock"
                iconSize={100}
              />
            </div>
            <div className="menu">
              <MenuCard
                title="Slack"
                icon="https://www.pulseway.com/Images/features/patch/3pp-logos/Slack.png"
                target="https://thndrapp.slack.com/"
              />
              <MenuCard
                title="Superset"
                icon="https://www.know-bi.be/hubfs/42724554.png"
                target="https://analytics.thndr-internal.app"
              />
              <MenuCard
                title="Translation Tool"
                icon="https://storage.googleapis.com/images.thndr.app/portal-icons/translation.png"
                target="https://usertool.thndr-internal.app/translation/"
                iconSize={100}
              />
              <MenuCard
                title="Tribal Credit"
                icon={tribalCredit}
                target="https://app.tribalcredit.io/login"
              />
              <MenuCard
                title="User Tool "
                icon="https://storage.googleapis.com/images.thndr.app/portal-icons/user.png"
                target="https://usertool.thndr-internal.app/users/"
                iconSize={100}
              />
              <MenuCard
                title="BOOM Tool "
                icon="https://boom.thndr.app/boomLogo.png"
                target="https://boom.thndr.app/"
                iconSize={100}
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default App;
